import { render, staticRenderFns } from "./CheckoutItemLineBelowNameHook.vue?vue&type=template&id=dd9974b4&"
import script from "./CheckoutItemLineBelowNameHook.js?vue&type=script&lang=js&"
export * from "./CheckoutItemLineBelowNameHook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports